import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Submenu {
  name: string;
  link: string;
}

interface RoleMenu {
  menu: string;
  submenus: Submenu[];
}

interface UserData {
  id?: string | number;
  email?: string;
  name?: string;
  token?: string;
  role?: string;
  consignees?: any[];
  roleMenuList?: RoleMenu[];
}

interface AuthState {
  isAuthenticated: boolean;
  user: UserData | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  loading: false,
  error: null
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<UserData>) => {
      state.isAuthenticated = true;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      // Clear the token from localStorage
      localStorage.removeItem('authToken');

      // Reset the auth state
      state.isAuthenticated = false;
      state.user = null;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const { loginRequest, loginSuccess, loginFailure, logout, clearError } = AuthSlice.actions;

export const AuthReducer = AuthSlice.reducer; 